import { useContext } from 'react';
import { DownloadAccessContext } from './DownloadAccessContext';

export const useDownloadGate = () => {
  const context = useContext(DownloadAccessContext);
  if (!context) {
    throw new Error('useDownloadGate must be used within DownloadAccessProvider');
  }

  return context;
};
